var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAttention(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 53,
    height: 55,
    viewBox: "0 0 53 55",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#DD5860",
    fillRule: "evenodd",
    d: "M28.097 1.13c.613.295 1.107.79 1.402 1.402L52.402 50.12c.718 1.493.09 3.286-1.402 4.005-.406.195-.851.296-1.301.296H3.893c-1.657 0-3-1.343-3-3 0-.45.101-.895.297-1.3L24.092 2.531c.719-1.493 2.512-2.12 4.005-1.402zm-1.301 41.225c-.832 0-1.506.674-1.506 1.505 0 .832.674 1.506 1.506 1.506.831 0 1.505-.674 1.505-1.506 0-.831-.674-1.505-1.505-1.505zm0-24.086c-.5 0-.904.404-.904.903V35.43c0 .499.405.903.904.903s.903-.404.903-.903V19.172c0-.499-.404-.903-.903-.903z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttention);
export default __webpack_public_path__ + "static/media/attention.dc0f31253674637510cf37cdf2f0a411.svg";
export { ForwardRef as ReactComponent };